import { FC, memo } from 'react'
import {
  DEFAULT_VARIATION_OPTIONS_BY_TYPE,
  EVariationTypes,
} from 'core/common/constants/multivariation'
import i18n from 'core/common/i18n'
import { TVariationsData } from 'core/components/Variations/types'
import VariationInputRenderer from 'core/components/Variations/VariationInputRenderer'
import { IOptionProps } from 'core/components/VariationsAutocompleteField/types'
import { useAppContext } from 'core/pages/ProductNew-v2/context/AppContext'

interface IVariationFieldProps {
  variationType: EVariationTypes
  variations: TVariationsData
  setFieldValue: (newValue: IOptionProps[]) => void
  value: IOptionProps[]
  error?: string
  onChange: () => void
}

const VariationField: FC<IVariationFieldProps> = ({
  variationType,
  variations,
  setFieldValue,
  value,
  error,
  onChange,
}) => {
  const { defaultVariationOptionsByType } = useAppContext()

  return (
    <VariationInputRenderer
      error={error}
      inputLabel={i18n.t(`multivariation.types.${variationType}`)}
      showAvatar={variationType === EVariationTypes.COLOR}
      options={
        defaultVariationOptionsByType
          ? defaultVariationOptionsByType[variationType]
          : DEFAULT_VARIATION_OPTIONS_BY_TYPE[variationType]
      }
      variations={variations}
      onChange={(_, newValue) => {
        setFieldValue(newValue as IOptionProps[])
        onChange()
      }}
      value={value}
    />
  )
}

export default memo(VariationField)
